import styled from 'styled-components';
import { space, layout, grid, flexbox, typography, position } from 'styled-system';
import React, { useState } from 'react';
import Icon from '@onedesign/icon';
import { Box as Box$1 } from '@oneboard/ui-components';
import PropTypes from 'prop-types';
import { Select as Select$1, Switch as Switch$1, Checkbox, Popover as Popover$1 } from 'antd';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject$9;
var Box = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), space, layout, grid, flexbox, typography, position);

var _templateObject$8;
var StyledButton = styled.button.attrs(function (props) {
  return {
    className: props.className
  };
})(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  display: inline-block;\n  padding: 6px 24px;\n  color: ", ";\n  background: #33353A;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 24px;\n  cursor: ", ";\n  border: none;\n  appearance: none;\n  outline: none;\n  transition: 0.35s;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? '#454B5C' : '#fff';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? '#33353A' : '#2D2F35';
});

var Button = function Button(_ref) {
  var className = _ref.className,
      title = _ref.title,
      onClick = _ref.onClick,
      children = _ref.children,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(StyledButton, {
    className: className,
    "data-testid": "Button",
    title: title,
    onClick: onClick,
    disabled: disabled
  }, children);
};

var _templateObject$7, _templateObject2$2;
var StyledModal = styled(Box$1).attrs(function (props) {
  return {
    className: props.className
  };
})(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10000;\n\n  > .wrapper {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 700px;\n    transform: translateX(-50%) translateY(-50%);\n    min-width: 40vw;\n    height: auto;\n    min-width: 20vw;\n    max-height: 90vh;\n    border-radius: 12px;\n    background-color: ", ";\n    color: ", ";\n    /* padding: 30px 36px; */\n    display: flex;\n    flex-direction: column;\n\n    > .body {\n      display: flex;\n      flex-direction: column;\n      padding: 0 24px 31px;\n      overflow: hidden;\n      color: #637381;\n      font-size: 16px;\n    }\n\n    .closeButton {\n      display: flex;\n      justify-content: flex-end;\n      cursor: pointer;\n    }\n  }\n\n  > .background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #232323;\n    opacity: 0.4;\n    z-index: -1;\n    cursor: pointer;\n  }\n"])), function (_ref) {
  var type = _ref.type;

  if (type === 'white') {
    return '#fff';
  }

  return '#fff';
}, function (_ref2) {
  var type = _ref2.type;

  if (type === 'white') {
    return '#2F3746';
  }

  return '#D6DAE0';
});
var StyledHeader = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 18px;\n  font-weight: 700;\n  color: #212b36;\n  padding: 16px 24px 16px 24px;\n"])));

var Modal = function Modal(_ref) {
  var className = _ref.className,
      children = _ref.children,
      header = _ref.header,
      onClose = _ref.onClose,
      width = _ref.width,
      _ref$closeIcon = _ref.closeIcon,
      closeIcon = _ref$closeIcon === void 0 ? true : _ref$closeIcon,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type;
  return /*#__PURE__*/React.createElement(StyledModal, {
    className: className,
    type: type,
    "data-testid": "Modal"
  }, /*#__PURE__*/React.createElement(Box, {
    className: "background",
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Box, {
    className: "wrapper",
    width: width
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 3
  }, header && /*#__PURE__*/React.createElement(StyledHeader, null, header, closeIcon && /*#__PURE__*/React.createElement(Box, {
    className: "closeButton",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "XmarkOutline",
    size: "xs",
    color: "#637381"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, children)));
};

var _templateObject$6;
var StyledLoading = styled.div.attrs(function (props) {
  return {
    className: props.className
  };
})(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  display: flex;\n  > .dot {\n    transform: translateY(-100%);\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: white;\n    margin: 0 5px;\n    animation: upDown 1s ease alternate infinite;\n    background-color: #A1A4B1;;\n\n    &:nth-child(1) {\n        animation-delay: 0.5s;\n    }\n\n    &:nth-child(2) {\n      animation-delay: 0.25s;\n\n    }\n\n    @keyframes upDown {\n      0% {\n        transform: translateY(-100%);\n      }\n\n      100% {\n        transform: translateY(100%);\n      }\n    }\n\n  }\n\n"])));

var Loading = function Loading(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledLoading, {
    className: className,
    "data-testid": "Loading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dot"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dot"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dot"
  }));
};

var _templateObject$5;
var UiBasicLayout = styled(Box)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-areas: 'main' 'bottom';\n  grid-template-rows: 1fr 60px;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n"])));
var BasicLayout = function BasicLayout(_ref) {
  var children = _ref.children,
      bottom = _ref.bottom;
  return /*#__PURE__*/React.createElement(UiBasicLayout, null, /*#__PURE__*/React.createElement(Box, {
    gridArea: "main"
  }, children), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    gridArea: "bottom"
  }, bottom));
};
BasicLayout.propTypes = {
  bottom: PropTypes.node,
  children: PropTypes.node
};

var _templateObject$4, _templateObject2$1;
var StyledSelect = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  position: relative;\n  > .ant-select {\n    width: 100%;\n    background-color: #fff;\n    border-radius: 8px !important;\n    border: 1px solid #637381;\n  }\n  .ant-select-selector {\n    width: 100%;\n    height: 52px !important;\n    color: #fff;\n    padding: 12px 35px 12px 12px !important;\n  }\n\n  .ant-select-focused .ant-select-selector,\n  .ant-select-selector:focus,\n  .ant-select-selector:active,\n  .ant-select-open .ant-select-selector {\n    box-shadow: none !important;\n  }\n\n  .ant-select-selection-item {\n    line-height: 24px !important;\n    color: #919eab;\n    font-size: 16px;\n  }\n\n  .ant-select-disabled .ant-select-selection-item {\n    color: rgba(0, 0, 0, 0.25);\n  }\n\n  .ant-select-item {\n    padding: 12px;\n    font-size: 14px;\n    color: #fff;\n    background-color: #2f3746;\n  }\n\n  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n    background-color: #fff;\n  }\n\n  .ant-select-selection-item {\n    line-height: 24px !important;\n    color: #919eab;\n    font-size: 16px;\n  }\n\n  .ant-select-dropdown {\n    /* background-color: #2f3746; */\n    border-radius: 4px;\n  }\n\n  .ant-select-item-option {\n    background-color: #fff;\n    color: #919eab;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    &:hover {\n      background-color: #dadada;\n    }\n  }\n"])));
styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  width: 24px;\n  height: 24px;\n  pointer-events: auto;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:after {\n    content: '';\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    background-image: url('/chevron_down_outline.svg');\n    background-size: cover;\n    .isOpen & {\n      transform: rotate(180deg);\n    }\n  }\n"])));

var Option = function Option(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return /*#__PURE__*/React.createElement(Select$1.Option, {
    value: value
  }, children);
};
var Select = function Select(_ref2) {
  var children = _ref2.children,
      onChange = _ref2.onChange,
      defaultValue = _ref2.defaultValue,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      className = _ref2.className;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownVisible = _useState2[0],
      setDropdownVisible = _useState2[1];

  var dropdownVisibleHandler = function dropdownVisibleHandler(state) {
    setDropdownVisible(state);
  };

  return /*#__PURE__*/React.createElement(StyledSelect, {
    className: dropdownVisible ? 'isOpen' : '',
    "data-testid": "Select"
  }, /*#__PURE__*/React.createElement(Select$1, {
    className: className,
    onSelect: onChange,
    showArrow: true,
    bordered: false,
    defaultValue: defaultValue,
    getPopupContainer: function getPopupContainer(triggerNode) {
      return triggerNode.parentElement;
    },
    onDropdownVisibleChange: dropdownVisibleHandler,
    disabled: disabled,
    suffixIcon: /*#__PURE__*/React.createElement(Icon, {
      name: dropdownVisible ? 'ChevronUpOutline' : 'ChevronDownOutline',
      size: "sm",
      color: "#637381"
    })
  }, children));
};

Select.Option = Option;

var _templateObject$3;
var StyledSwitch = styled.div.attrs(function (props) {
  return {
    className: props.className
  };
})(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  /* .ant-switch{\n    min-width: 51px;\n    height: 31px;\n    background-color: rgba(120, 120, 128, 0.16);;\n    \n    &.ant-switch-checked {\n      background-color: #EC7963;\n    }\n  }\n  \n  .ant-switch-handle{\n    width: 27px;\n    height: 27px;\n  }\n  .ant-switch-handle::before{\n    border-radius: 50%;\n  }\n  .ant-switch-checked .ant-switch-handle{\n    left: calc(100% - 27px - 2px);\n  } */\n"])));

var Switch = function Switch(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(StyledSwitch, {
    className: className,
    "data-testid": "Switch"
  }, /*#__PURE__*/React.createElement(Switch$1, {
    defaultChecked: checked,
    onChange: onChange,
    disabled: disabled
  }));
};

var _templateObject$2;
var StyledCheckBox = styled.div.attrs(function (props) {
  return {
    className: props.className
  };
})(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #ec7963;\n  }\n  .ant-checkbox-inner {\n    border-color: #ec7963;\n  }\n  .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n  .ant-checkbox:hover .ant-checkbox-inner,\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: #ec7963;\n  }\n  .ant-checkbox-checked::after {\n    border-color: #ec7963;\n  }\n"])));

var CheckBox = function CheckBox(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      onChange = _ref.onChange,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledCheckBox, {
    "data-testid": "CheckBox"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    className: className,
    checked: checked,
    onChange: onChange
  }, children));
};

var _templateObject$1, _templateObject2;
var StyledFullButton = styled.button.attrs(function (props) {
  return {
    className: props.className
  };
})(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    display: inline-block;\n    width: 100%;\n    padding: 16px 8px;\n    color: #fff;\n    border-radius: 12px;\n    font-size: 16px;\n    line-height: 24px;\n    border: none;\n    appearance: none;\n    outline: none;\n    cursor: pointer;\n    transition: 0.35s;\n    background-color: #ec7963;\n\n    &:hover {\n        background-color: #ee8773;\n    }\n\n    &:disabled {\n        color: #2f3746;\n        cursor: not-allowed;\n        background-color: #232a37;\n    }\n"])));
var StyledSecondlyButton = styled(StyledFullButton)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    &:hover {\n        background-color: ", ";\n    }\n\n    &:disabled {\n        color: #2f3746;\n        cursor: not-allowed;\n        background-color: #232a37;\n    }\n"])), function (_ref) {
  var color = _ref.color;
  return color ? color : '#232A37';
}, function (_ref2) {
  var color = _ref2.color;
  return color ? color : '#232A37';
});

var SecondlyFullButton = function SecondlyFullButton(_ref) {
  var className = _ref.className,
      title = _ref.title,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      color = _ref.color,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledSecondlyButton, {
    className: className,
    title: title,
    onClick: onClick,
    disabled: disabled,
    color: color
  }, children);
};

var FullButton = function FullButton(_ref2) {
  var className = _ref2.className,
      title = _ref2.title,
      onClick = _ref2.onClick,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement(StyledFullButton, {
    className: className,
    "data-testid": "FullButton",
    title: title,
    onClick: onClick,
    disabled: disabled
  }, children);
};

FullButton.Secondly = SecondlyFullButton;

var _templateObject;
var StyledPopover = styled(Popover$1)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n     .ant-popover  {\n       \n       .ant-popover-content {\n\n         .ant-popover-arrow {\n           display: ", ";\n           border-color: #232323 !important;\n         }\n\n         .ant-popover-inner {\n            background: #fff;\n            border-radius: 24px;\n            overflow: hidden;\n            .ant-popover-title {\n              padding: 12px;\n              text-align: center;\n              color: #fff;\n              border-bottom: none;\n            }\n\n            .ant-popover-inner-content {\n              color: #fff;\n              padding: 0;\n            }\n\n          }\n\n      }\n    }\n    \n"])), function (_ref) {
  var arrow = _ref.arrow;
  return arrow ? 'block' : 'none';
});

var Popover = function Popover(props) {
  var children = props.children,
      title = props.title,
      content = props.content,
      trigger = props.trigger,
      placement = props.placement,
      visible = props.visible,
      _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      onVisibleChange = props.onVisibleChange;
  return /*#__PURE__*/React.createElement(StyledPopover, {
    arrow: arrow,
    placement: placement,
    title: title,
    content: content,
    trigger: trigger,
    visible: visible,
    getPopupContainer: function getPopupContainer(triggerNode) {
      return triggerNode;
    },
    onVisibleChange: onVisibleChange,
    "data-testid": "Popover"
  }, children);
};

export { BasicLayout, Box, Button, CheckBox, FullButton, Loading, Modal, Popover, Select, Switch };
